import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type ThemeModeIcon = 'light' | 'auto' | 'dark';

function assertThemeModeIcon(value: ThemeModeIcon): ThemeModeIcon {
	switch (value) {
		case 'light':
		case 'auto':
		case 'dark':
			return value;
		default:
			throw new Error(
				`JeptoThemeModeIcon: invalid mode "${String(value)}" (expected light, auto, or dark)`,
			);
	}
}

@Component({
	selector: 'jepto-theme-mode-icon',
	standalone: true,
	templateUrl: './jepto-theme-mode-icon.component.html',
	styleUrl: './jepto-theme-mode-icon.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThemeModeIconComponent {
	readonly mode = input.required<ThemeModeIcon, ThemeModeIcon>({
		transform: assertThemeModeIcon,
	});
}
